import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store'
import './directives/permission'
import './directives/contextmenu'
// 任务1(0904)：出入库列表照片列公共样式（photo-cell/photo-thumb/...——六页共用）
import './assets/photo-column.css'
import DataActionBar from '@/components/DataActionBar/index.vue'
import QuantityDisplay from '@/components/QuantityDisplay/index.vue'   // 任务C：数量+单位统一展示

Vue.config.productionTip = false
Vue.use(ElementUI)

// 任务6 → A-1.2：基础数据页可编辑判断——ERP 主导（WMS_MES_ERP）时增删改按钮隐藏
// （store.sysConnection：ONLY_WMS/WMS_MES=本地维护可增删改；WMS_MES_ERP=ERP 同步数据页面只读）
Vue.mixin({
  computed: {
    isErpDisconnected() {
      return (this.$store.state.sysConnection || 'ONLY_WMS') !== 'WMS_MES_ERP'
    }
  }
})
Vue.component('DataActionBar', DataActionBar)
Vue.component('QuantityDisplay', QuantityDisplay)   // 任务C：全局注册（16 页免重复 import）

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
